(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rating", [], factory);
	else if(typeof exports === 'object')
		exports["rating"] = factory();
	else
		root["rating"] = factory();
})(this, function() {
return 